"use strict";
var _a;
exports.__esModule = true;
exports.sliceMapper = void 0;
var anchor_list_slice_1 = require("./anchor-list-slice");
var article_list_slice_1 = require("./article-list-slice");
var card_list_slice_1 = require("./card-list-slice");
var download_links_slice_1 = require("./download-links-slice");
var exergue_slice_1 = require("./exergue-slice");
var footnotes_slice_1 = require("./footnotes-slice");
var heading2_slice_1 = require("./heading2-slice");
var headnote_slice_1 = require("./headnote-slice");
var image_slice_1 = require("./image-slice");
var insert_slice_1 = require("./insert-slice");
var interview_slice_1 = require("./interview-slice");
var key_numbers_slice_1 = require("./key-numbers-slice");
var large_card_grid_slice_1 = require("./large-card-grid-slice");
var list_slice_1 = require("./list-slice");
var press_release_list_slice_1 = require("./press-release-list-slice");
var slider_hero_slice_1 = require("./slider-hero-slice");
var text_slice_1 = require("./text-slice");
var text_with_image_slice_1 = require("./text-with-image-slice");
var twitter_carousel_slice_1 = require("./twitter-carousel-slice");
var video_hero_slice_1 = require("./video-hero-slice");
var PrismicSliceType;
(function (PrismicSliceType) {
    PrismicSliceType["AnchorList"] = "anchor_list";
    PrismicSliceType["DownloadLinks"] = "download_links";
    PrismicSliceType["Exergue"] = "exergue";
    PrismicSliceType["Footnotes"] = "footnotes";
    PrismicSliceType["Headnote"] = "headnote";
    PrismicSliceType["Heading2"] = "heading_2";
    PrismicSliceType["Image"] = "image";
    PrismicSliceType["Insert"] = "insert";
    PrismicSliceType["Interview"] = "interview";
    PrismicSliceType["KeyNumbers"] = "key_numbers";
    PrismicSliceType["List"] = "list";
    PrismicSliceType["Text"] = "text";
    PrismicSliceType["TextWithImage"] = "text_with_image";
    PrismicSliceType["ArticleList"] = "article_list";
    PrismicSliceType["PressReleaseList"] = "press_release_list";
    PrismicSliceType["TwitterCarousel"] = "twitter_carousel";
    PrismicSliceType["LargeCardGrid"] = "large_card_grid";
    PrismicSliceType["CardList"] = "card_list";
    PrismicSliceType["VideoHero"] = "video_hero";
    PrismicSliceType["SliderHero"] = "slider_hero";
})(PrismicSliceType || (PrismicSliceType = {}));
exports.sliceMapper = (_a = {},
    _a[PrismicSliceType.AnchorList] = anchor_list_slice_1.toAnchorListSlice,
    _a[PrismicSliceType.ArticleList] = article_list_slice_1.toArticleListSlice,
    _a[PrismicSliceType.CardList] = card_list_slice_1.toCardListSlice,
    _a[PrismicSliceType.DownloadLinks] = download_links_slice_1.toDownloadLinksSlice,
    _a[PrismicSliceType.Exergue] = exergue_slice_1.toExergueSlice,
    _a[PrismicSliceType.Footnotes] = footnotes_slice_1.toFootnotesSlice,
    _a[PrismicSliceType.Headnote] = headnote_slice_1.toHeadnoteSlice,
    _a[PrismicSliceType.Heading2] = heading2_slice_1.toHeading2Slice,
    _a[PrismicSliceType.Image] = image_slice_1.toImageSlice,
    _a[PrismicSliceType.Insert] = insert_slice_1.toInsertSlice,
    _a[PrismicSliceType.Interview] = interview_slice_1.toInterviewSlice,
    _a[PrismicSliceType.KeyNumbers] = key_numbers_slice_1.toKeynumbersSlice,
    _a[PrismicSliceType.List] = list_slice_1.toListSlice,
    _a[PrismicSliceType.LargeCardGrid] = large_card_grid_slice_1.toLargeCardGridSlice,
    _a[PrismicSliceType.Text] = text_slice_1.toTextSlice,
    _a[PrismicSliceType.TextWithImage] = text_with_image_slice_1.toTextWithImageSlice,
    _a[PrismicSliceType.PressReleaseList] = press_release_list_slice_1.toPressReleaseListSlice,
    _a[PrismicSliceType.TwitterCarousel] = twitter_carousel_slice_1.toTwitterCarouselSlice,
    _a[PrismicSliceType.VideoHero] = video_hero_slice_1.toVideoHeroSlice,
    _a[PrismicSliceType.SliderHero] = slider_hero_slice_1.toSliderHeroSlice,
    _a);
//# sourceMappingURL=slice-mapper.js.map